import { useState, useEffect, useRef } from "react";
import "./SearchproductFilter.css";
import { printDebugLog } from "../../Utils/utils";
import { IMAGE_URL } from "../../Utils/constant";
import { useNavigate } from "react-router-dom";

const SearchproductFilter = ({
    filteredOptions = [],
    searchQuery = "",
    setSearchQuery,
    onClose,
}) => {
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const wrapperRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setDropdownVisible(false);
                setHighlightedIndex(-1);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const resetSearchState = () => {
        setDropdownVisible(false);
        setHighlightedIndex(-1);
        onClose();
    };

    const handleSelect = (item) => {
        printDebugLog("handleSelect", item);
        resetSearchState();
        navigate("/view/products", { state: { inventory: item } });
    };

    const handleOnChange = async (e) => {
        const value = e.target.value;
        setSearchQuery(value);
        if (value.length < 3) {
            setDropdownVisible(false);
            setHighlightedIndex(-1);
            return;
        }
        setDropdownVisible(true);
    };

    const handleCloseSearch = () => {
        resetSearchState();
        if (onClose) onClose();
    };

    return (
        <div className="search-wrapper" ref={wrapperRef}>
            <div
                className="search-text-input-container"
                onClick={() => setDropdownVisible(searchQuery.length >= 3)}
            >
                <input
                    type="text"
                    value={searchQuery}
                    placeholder="Search Items"
                    onChange={handleOnChange}
                    onFocus={() => {
                        if (searchQuery.length >= 3) {
                            setDropdownVisible(true);
                        }
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Escape") {
                            handleCloseSearch();
                            return;
                        }

                        if (!dropdownVisible || filteredOptions.length === 0) return;

                        if (e.key === "ArrowDown") {
                            e.preventDefault();
                            setHighlightedIndex((prev) => (prev + 1) % filteredOptions.length);
                        } else if (e.key === "ArrowUp") {
                            e.preventDefault();
                            setHighlightedIndex((prev) =>
                                prev <= 0 ? filteredOptions.length - 1 : prev - 1
                            );
                        } else if (e.key === "Enter" && highlightedIndex >= 0) {
                            e.preventDefault();
                            handleSelect(filteredOptions[highlightedIndex]);
                        }
                    }}
                />
            </div>

            {dropdownVisible && filteredOptions.length > 0 && (
                <ul className="search-dropdown">
                    {filteredOptions.map((product, index) => (
                        <li
                            key={product._id}
                            onClick={() => handleSelect(product)}
                            className={highlightedIndex === index ? "highlighted" : ""}
                            onMouseEnter={() => setHighlightedIndex(index)}
                        >
                            <div
                                className={`product-search-item ${highlightedIndex === index ? "active" : ""
                                    }`}
                            >
                                <img
                                    src={`${IMAGE_URL}${product.firstImage}`}
                                    alt={product.name}
                                    className="s-product-thumb"
                                />
                                <div className="s-product-info">
                                    <div className="s-product-name">{product.name}</div>
                                    <div className="s-product-meta">
                                        <span className="s-brand">{product.brand}</span>
                                        <span className="s-category">{product.catgName}</span>
                                    </div>
                                    <div className="s-product-other">{product.movementType}</div>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export { SearchproductFilter };